export const featureflagsProspectOverviewProperties = {
  title: "Coordinate product launches with Feature Flags",
  subtitle: "Release, test, and measure new feature launches with Braze Feature Flags",
  "button-color-intent": "warning" as "warning" | "info" | "success" | "danger",
};
